export default "__VITE_ASSET__be71c8b6__"